module.exports = __webpack_public_path__ + "static/media/google-play-badge-en.b249a1f0.png";